import { CheckboxAnswer, TextAnswer } from './anwer-types';
import { useItem } from './hooks/use-context';
import { AnswerData, QuestionData } from './types';

export function Providences() {
  const { sections } = useItem();

  const questions = sections.flatMap((section) => section.questions);

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        marginBottom: '20px',
      }}
    >
      <h1
        style={{
          textAlign: 'left',
          marginBottom: '10px',
          fontSize: '16px',
          fontWeight: 'bold'
        }}
      >
        Providências
      </h1>

      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          border: '1px solid #ddd',
          marginBottom: '20px',
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '10%',
              }}
            >
              ID
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '50%',
              }}
            >
              Providência
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '20%',
              }}
            >
              Responsável
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'center',
                backgroundColor: '#FAE0CD',
                width: '20%',
              }}
            >
              Prazo
            </th>
          </tr>
        </thead>
        <tbody>
          {[
            '7a0a1aa7-d21a-4975-a4fd-7ad366edd9fa',
            '97b998de-81f3-4dd4-bee6-4d30dfc86a84',
            '1f9b9cc9-ad20-4d46-9c9c-aa27358f004c',
            '25662d4e-d7ad-4a78-afe2-41f5a21c5370',
          ].map((id, index) => {
            const questionChildren = questions?.filter((q) =>
              q.answers.every(
                (answer) =>
                  answer.question_parent_option_id ===
                  questions.find((question) => question.question_id === id)
                    ?.answers?.[0].content,
              ),
            );

            return (
              <tr key={id}>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    textAlign: 'center',
                  }}
                >
                  {(index + 1).toString().padStart(2, '0')}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {
                    questionChildren.find(
                      (question) => question.type === 'text',
                    )?.answers?.[0].content
                  }
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {
                    questionChildren.find(
                      (question) => question.type === 'user',
                    )?.answers?.[0].content
                  }
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {
                    questionChildren.find(
                      (question) => question.type === 'date',
                    )?.answers?.[0].content
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid #69CC8D',
          borderRadius: '5px',
          backgroundColor: '#FFFFFF',
          padding: '6px',
          minHeight: '100px',
          flex: 1,
        }}
      >
        <div style={{ color: 'GrayText', marginRight: '6px' }}>
          Participação do Comitê:
        </div>
        <div>
          {
            questions.find(
              (question) =>
                question.question_id === '9e5da2fa-27d7-4c97-94d6-bb0bdc7811d6',
            )?.answers?.[0]?.content
          }
        </div>
      </div>
    </div>
  );
}
